module.exports = __webpack_public_path__ + "img/egg-fried.fbcfbd46.svg";